import
{
    type LexicalCommand,
    createCommand,
    $getSelection, $isRangeSelection, $isRootNode,
    // $createRangeSelection, $getSelection, $isNodeSelection, $isRangeSelection, $isRootNode, $setSelection,
    COMMAND_PRIORITY_EDITOR,
    LexicalEditor,
    // NodeKey, // COMMAND_PRIORITY_HIGH, COMMAND_PRIORITY_LOW, DRAGOVER_COMMAND, DRAGSTART_COMMAND, DROP_COMMAND
}
from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { useEffect } from 'react';
import { $createInlineImageNode, InlineImageNode } from '../nodes/InlineImageNode';
import { ImageProperties } from '../components/Image';

export const INSERT_IMAGE_COMMAND: LexicalCommand<any> = createCommand();

export function dispatchInsertImageCommand(editor: LexicalEditor, src: string)
{
    const payload: ImageProperties =
    {
        src
    };
    editor.dispatchCommand(INSERT_IMAGE_COMMAND, payload);
}

export default function InlineImagePlugin(): JSX.Element | null
{
    const [editor] = useLexicalComposerContext();
    const onInit = () =>
    {
        if (!editor.hasNodes([InlineImageNode]))
        {
            throw new Error('ImagesPlugin: ImageNode not registered on editor.');
        }
        const insertCommand = editor.registerCommand<ImageProperties>
        (
            INSERT_IMAGE_COMMAND,
            properties =>
            {
                const selection = $getSelection();
                if ($isRangeSelection(selection))
                {
                    if ($isRootNode(selection.anchor.getNode()))
                    {
                        selection.insertParagraph();
                    }
                    const imageNode = $createInlineImageNode(properties);
                    selection.insertNodes([imageNode]);
                }
                return true;
            },
            COMMAND_PRIORITY_EDITOR,
        );
        return mergeRegister(insertCommand);
    };
    useEffect(onInit, [editor]);
    return null;
}